import api from 'Service';
import { apiViaCep } from 'View/Service/viacep';

import aula from './Aula';
import autenticacao from './Autenticacao';
import config from './Config';

export default {
  aula,
  autenticacao,
  config,
  [api.reducerPath]: api.reducer,
  [apiViaCep.reducerPath]: apiViaCep.reducer,
};
